<div class="offcanvas offcanvas-start" tabindex="-1" id="groups" aria-labelledby="groups_label">
  <div class="offcanvas-body">
    <div class="d-flex justify-content-between align-items-center mt-5">
      <h5 class="offcanvas-title mx-2" id="groups_label">
        {{ school_domain ? 'Classes' : 'Groups' }}
      </h5>
      <button
        type="button"
        class="btn-close text-reset me-2"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>

    <div v-if="isLoading" class="portal-sidebar-card border mt-3">
      <div class="portal-sidebar-body text-center py-4 px-3">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 mb-0 text-muted text-xxs">
          Loading {{ school_domain ? 'Classes' : 'Groups' }}...
        </p>
      </div>
    </div>

    <div v-else-if="groups.length" class="portal-sidebar-card portal-sidebar-card-list mt-3">
      <div class="portal-sidebar-header d-flex align-items-center justify-content-between rounded">
        <h6 class="mb-0">All {{ school_domain ? 'Classes' : 'Groups' }}</h6>
        <button
          v-if="(school_domain && user_details.user_role === 'admin') || !school_domain"
          class="portal-sidebar-avatar border-0"
          type="button"
          title="Create New"
          @click="openCreateGroupModal"
        >
          <i class="bi bi-plus-lg"></i>
        </button>
      </div>

      <div class="portal-sidebar-body">
        <div class="portal-sidebar-list d-flex flex-column">
          <div
            v-for="group in groups"
            :key="group.id"
            class="portal-sidebar-item cursor-pointer"
            role="button"
            tabindex="0"
            @click="open_group(group)"
            @keyup.enter="open_group(group)"
          >
            <span class="portal-sidebar-avatar">
              <i :class="school_domain ? 'bx bxs-graduation' : 'bx bxs-group'"></i>
            </span>
            <span class="portal-sidebar-name">
              {{ group.name }}
            </span>
            <i v-if="!group.is_public" class="bx bxs-lock portal-sidebar-lock"></i>

            <div
              v-if="String(group?.created_by?.id) === String(user_id)"
              class="dropdown ms-auto"
              @click.stop
            >
              <button
                class="btn btn-sm border-0 p-0 d-inline-flex align-items-center justify-content-center"
                type="button"
                data-bs-toggle="dropdown"
                aria-label="Group actions"
              >
                <i class="bx bx-dots-vertical-rounded fs-5 text-dark"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-2 py-2 rounded-3">
                <li>
                  <a
                    class="dropdown-item text-xs py-2 d-flex align-items-center gap-2"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#create_group_modal"
                    @click="openEditGroupModal(group)"
                  >
                    <i class="bi bi-pencil fs-6 text-primary"></i>
                    <span class="fw-500">Edit</span>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider my-1">
                </li>
                <li>
                  <a
                    class="dropdown-item text-xs py-2 d-flex align-items-center gap-2 text-danger"
                    href="#"
                    @click.prevent="deleteGroup(group.id)"
                  >
                    <i class="bi bi-trash fs-6"></i>
                    <span class="fw-500">Delete</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="portal-sidebar-card border mt-3">
      <div class="portal-sidebar-body text-center py-4 px-3">
        <button
          v-if="(school_domain && user_details.user_role === 'admin') || !school_domain"
          class="portal-sidebar-avatar border-0 mb-3"
          type="button"
          title="Create New"
          @click="openCreateGroupModal"
        >
          <i class="bi bi-plus-lg"></i>
        </button>
        <h6 class="fw-bold mb-1">No {{ school_domain ? 'classes' : 'groups' }} yet</h6>
        <p class="mb-0 text-muted text-xs">
          Create your first {{ school_domain ? 'class' : 'group' }} to get started.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="d-none d-xl-block" v-if="!isHomePage">
  <div v-if="isLoading" class="portal-sidebar-card-compact mt-2">
    <div class="portal-sidebar-body text-center py-4 px-3">
      <div class="spinner-border spinner-border-sm text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 mb-0 text-muted text-xxs">
        Loading {{ school_domain ? 'Classes' : 'Groups' }}...
      </p>
    </div>
  </div>

  <div v-else-if="groups.length" class="portal-sidebar-card-compact mt-2">
    <div class="portal-sidebar-header d-flex justify-content-between align-items-center rounded">
      <h6 class="mb-0">
        {{ school_domain ? 'Classes' : 'Groups' }}
      </h6>
      <button
        class="portal-sidebar-avatar border-0"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#create_group_modal"
        @click="editing=false"
        title="Create New"
        v-if="(school_domain && user_details.user_role === 'admin') || !school_domain"
      >
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>

    <div class="portal-sidebar-body">
      <div class="portal-sidebar-list d-flex flex-column">
        <div
          v-for="group in visible_desktop_groups"
          :key="group.id"
          class="portal-sidebar-item cursor-pointer"
          role="button"
          tabindex="0"
          @click="open_group(group)"
          @keyup.enter="open_group(group)"
        >
          <span class="portal-sidebar-avatar">
            <i :class="school_domain ? 'bx bxs-graduation' : 'bx bxs-group'"></i>
          </span>
          <span class="portal-sidebar-name">
            {{ group.name }}
          </span>
          <i v-if="!group.is_public" class="bx bxs-lock portal-sidebar-lock"></i>

          <div
            v-if="String(group?.created_by?.id) === String(user_id)"
            class="dropdown ms-auto"
            @click.stop
          >
            <button
              class="btn btn-sm border-0 p-0 d-inline-flex align-items-center justify-content-center"
              type="button"
              data-bs-toggle="dropdown"
              aria-label="Group actions"
            >
              <i class="bx bx-dots-vertical-rounded fs-5 text-dark"></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-2 py-2 rounded-3">
              <li>
                <a
                  class="dropdown-item text-xs py-2 d-flex align-items-center gap-2"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#create_group_modal"
                  @click="openEditGroupModal(group)"
                >
                  <i class="bi bi-pencil fs-6 text-primary"></i>
                  <span class="fw-500">Edit</span>
                </a>
              </li>
              <li>
                <hr class="dropdown-divider my-1">
              </li>
              <li>
                <a
                  class="dropdown-item text-xs py-2 d-flex align-items-center gap-2 text-danger"
                  href="#"
                  @click.prevent="deleteGroup(group.id)"
                >
                  <i class="bi bi-trash fs-6"></i>
                  <span class="fw-500">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <button
        v-if="has_more_desktop_groups"
        type="button"
        class="portal-sidebar-see-all btn btn-link btn-sm w-100 text-decoration-none"
        @click="toggle_desktop_groups"
      >
        {{ show_all_desktop_groups ? 'See Less' : 'See All' }}
      </button>
    </div>
  </div>

  <div v-else class="portal-sidebar-card-compact mt-2">
    <div class="portal-sidebar-body text-center py-4 px-3">
      <button
        v-if="(school_domain && user_details.user_role === 'admin') || !school_domain"
        class="portal-sidebar-avatar border-0 mb-3"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#create_group_modal"
        title="Create New"
        @click="editing=false"
      >
        <i class="bi bi-plus-lg"></i>
      </button>
      <h6 class="fw-bold mb-1">No {{ school_domain ? 'classes' : 'groups' }} yet</h6>
      <p class="mb-0 text-muted text-xs">
        Create your first {{ school_domain ? 'class' : 'group' }} to get started.
      </p>
    </div>
  </div>
</div>
<teleport to="body">
  <div class="modal fade" id="create_group_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xs test fw-500" id="exampleModalLabel">
            {{ editing 
               ? (school_domain ? 'Edit Class' : 'Edit Group') 
               : (school_domain ? 'Add a Class' : 'Create a Group') 
            }}
          </p>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <form @submit.prevent="handleSubmit">
          <div class="modal-body">
            <div class="mb-3">
              <label for="group_name" class="form-label text-xs fw-500">
                {{ school_domain ? 'Class Name' : 'Group Name' }} 
                <span class="text-danger">*</span>
              </label>
              <input 
                type="text" 
                class="form-control rounded text-xs" 
                id="group_name" 
                v-model="group_name"
                :placeholder="school_domain ? 'Enter class name ( 12 B )' : 'Enter group name'"
              >
              <p v-if="errors.group_name" class="text-danger text-xs">{{ errors.group_name }}</p>
            </div>

            <div class="mb-3">
              <label for="group_description" class="form-label text-xs fw-500">
                {{ school_domain ? 'Class Description' : 'Group Description' }}
              </label>
              <textarea 
                class="form-control rounded text-xs" 
                id="group_description" 
                v-model="group_description"
                :placeholder="school_domain ? 'Enter class details' : 'Enter group description'"
              ></textarea>
            </div>

            <div class="mb-3">
              <label for="is_public" class="form-label text-xs fw-500">Visibility <span class="text-danger">*</span></label>
              <select class="form-select rounded text-xs" id="is_public" v-model="is_public" required>
                <option selected hidden>Select visibility type</option>
                <option value="true">Public</option>
                <option value="false">Private</option>
              </select>
            </div>
          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded">
              {{ editing ? 'Update' : 'Submit' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>
